import Layout from "../Layout";
import "./homepage.css"
import {
    HeaderTitle, HeaderDescription, PrimaryButton, HeaderBox
} from "./../../features/Atoms"
import {
} from "@material-ui/core";
import CourseTypesBlock from "./Blocks/CourseTypesBlock"
import WhyChooseBlock from "./Blocks/WhyChooseBlock"
import TestimonialBlock from "./Blocks/TestimonialBlock"
import LatestCourseBlock from "./Blocks/LatestCourseBlock"
import TheProcessBlock from "./Blocks/TheProcessBlock"
import TechWideWorldBlock from "./Blocks/TechWideWorldBlock"
import VirtualTutoringBlock from "./Blocks/VirtualTutoringBlock"
import AmazingTeachersBlock from "./Blocks/AmazingTeachersBlock"
import BannerBlockBlock from "./Blocks/BannerBlockBlock"
import BlogNewsBlock from "./Blocks/BlogNewsBlock"
import StatisticsBlock from "./Blocks/StatisticsBlock"
import indexImg from "./../../images/Indexbackground.jpg";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import { useState } from "react";
import ContactModal from './../../features/ContactModal';
export default function HomePage(props) {
    const [ contactModalStatus, setContactModalStatus ] = useState(false);

    return (
        <Layout>
            <HeaderBox coverPic={indexImg}>
                <HeaderTitle className="marginGapBottom">
                    The future is bright and filled with Tech.&nbsp;
                    <b className="greenText">
                        We get your child ready for it.
                    </b>
                </HeaderTitle>
                <HeaderDescription className="marginGapBottom">
                    Knowing what to learn and how to do it better and faster is essential.
                    Our expert educators lead the way and empower your children for
                    what comes next. Tutoring to boost education, Tech Courses to bring
                    innovation.
                </HeaderDescription>

                <Link onClick={()=>setContactModalStatus(true)} component={PrimaryButton} className="marginGapBottom">
                    Free 30min Computer Lesson</Link> &nbsp;&nbsp;
                {/* <PrimaryButtonOutlined className="marginGapBottom">Free 1hr Math Taining</PrimaryButtonOutlined> */}
            </HeaderBox>

            <ContactModal open={contactModalStatus} handleClose={()=>setContactModalStatus(false)}/> 

            <CourseTypesBlock />
            <WhyChooseBlock />
            <TestimonialBlock />
            <LatestCourseBlock />
            <TheProcessBlock />
            <TechWideWorldBlock />
            <StatisticsBlock />
            <VirtualTutoringBlock />
            <AmazingTeachersBlock />
            <BannerBlockBlock />
            <BlogNewsBlock />
        </Layout>
    );
}



